import React from "react";
import styled from "styled-components";
import TopNavbarForPolicy from "../components/Nav/TopNavbarForPolicy";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"

export default function Privacy() {
  return (
    <Wrapper>
    <TopNavbarForPolicy />
      <Container>
        <Title>Privacy Policy</Title>
        <Content>
          <Section>
            <p>
              Protecting your privacy is a priority for us at Sinly.
            </p>
            <p>
              Sinly provides services and develops software to assist merchants in enhancing their online sales efficiency through platforms like Shopify. This Privacy Policy outlines how we collect, use, retain, and disclose Personally Identifiable Information (“Personal Data”) that you provide while using Sinly websites, apps, and services (collectively referred to as “Services”). We encourage you to carefully read this Privacy Policy and our Terms and Conditions of Use to understand how we manage your Personal Data.
            </p>
            <p>
              Contact: sinlyapps@gmail.com
            </p>
          </Section>
          <Section>
            <SubTitle>Purpose</SubTitle>
            <p>
              Sinly may collect Personal Data such as your name, shipping and billing addresses, phone number, email address, payment information, IP address, and device identifiers in the course of providing our Services. We use and disclose this Personal Data as described in this Privacy Policy.
            </p>
            <p>
              Note to Residents of the European Union: To comply with the European General Data Protection Regulation (GDPR), this Privacy Policy outlines the legal basis on which we process your Personal Data and provides other necessary information.
            </p>
          </Section>
          <Section>
            <SubTitle>Consent and Collection of Personal Data</SubTitle>
            <p>
              We collect Personal Data when you interact with our websites, apps, or engage in transactions with Sinly, such as installing our apps, making purchases, or contacting us for support. We may collect data such as areas of our Services you visit, transaction details, IP addresses, and other relevant information to provide and improve our Services.
            </p>
          </Section>
          <Section>
            <SubTitle>Age of Consent</SubTitle>
            <p>
              Our Services are intended for users above the age of majority in their respective regions. We do not knowingly collect Personal Data from individuals below the age of majority. If we discover such data, we will promptly delete it upon verification.
            </p>
          </Section>
          <Section>
            <SubTitle>Anonymous Information</SubTitle>
            <p>
              Similar to most websites and apps, we collect anonymous technical information during your interactions with our Services to enhance functionality and user experience. This information is not personally identifiable and is used for statistical purposes.
            </p>
          </Section>
          <Section>
            <SubTitle>Personal Data Use</SubTitle>
            <p>
              Sinly uses Personal Data to establish user identities, manage accounts, provide support, enhance our websites, communicate with users, ensure security, and comply with legal requirements. We securely store and process Personal Data and retain it only as long as necessary for the purposes outlined or required by law.
            </p>
          </Section>
          <Section>
            <SubTitle>Security</SubTitle>
            <p>
              We employ physical, technical, and administrative measures to protect your Personal Data from unauthorized access, disclosure, alteration, or destruction. However, no method of data transmission over the internet or storage is completely secure.
            </p>
          </Section>
          <Section>
            <SubTitle>Disclosure of Personal Data</SubTitle>
            <p>
              We do not sell your Personal Data to third parties for marketing purposes. We may share Personal Data with trusted third-party service providers to operate our Services effectively. We may also disclose Personal Data in response to legal requests or to protect our rights and property.
            </p>
          </Section>
          <Section>
            <SubTitle>Transfers of Your Personal Data</SubTitle>
            <p>
              Your Personal Data may be processed and stored in countries with different data protection laws than your own. We take steps, including contractual measures, to ensure your Personal Data remains protected wherever it is processed.
            </p>
          </Section>
          <Section>
            <SubTitle>Cookies and Advertisers</SubTitle>
            <p>
              Our websites may use cookies to enhance user experience and personalize content. Third-party advertisers may also place cookies to track user interests for targeted advertising purposes. You can manage cookie settings in your browser, but disabling cookies may limit certain functionalities.
            </p>
          </Section>
          <Section>
            <SubTitle>Rights With Respect to Personal Data</SubTitle>
            <p>
              You have rights to access, correct, or request deletion of your Personal Data held by Sinly. If you have questions or wish to exercise these rights, please contact our Privacy Officer at sinlyapps@gmail.com.
            </p>
          </Section>
          <Section>
            <SubTitle>External Links</SubTitle>
            <p>
              Our Services may contain links to third-party websites or apps. We are not responsible for their privacy practices and recommend reviewing their privacy statements before providing Personal Data.
            </p>
          </Section>
          <Section>
            <SubTitle>Changes to this Privacy Policy</SubTitle>
            <p>
              Sinly reserves the right to modify this Privacy Policy at any time. We will notify you of significant changes. Your continued use of our Services after changes indicates your acceptance of the updated Privacy Policy.
            </p>
          </Section>
          <Section>
            <SubTitle>Contact & Questions</SubTitle>
            <p>
              For questions regarding this Privacy Policy or our Services, please contact the Sinly Privacy Officer at sinlyapps@gmail.com.
            </p>
          </Section>
        </Content>
        <Contact />
      </Container>
      <Footer />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 50px 20px;
  background-color: #f7f7f7;
  font-family: 'Khula', sans-serif;
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
`;

const Content = styled.div`
  margin-top: 20px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SubTitle = styled.h2`
  font-size: 1.5rem;
  color: #555;
  margin-bottom: 10px;
`;
